import { identity, unwrap } from "../api";
import type { IdentityComponents } from "@steelyard/api-client";

/**
 * The mobile apps' force-update policies (`../Steelyard` contracts/app-versions.md,
 * `AppVersionController.cs`). Every route here is `config.administer`. The anonymous
 * `GET /app-versions/check` is the mobile apps' call, not the back office's.
 */
export type AppVersionPolicy = IdentityComponents["schemas"]["AppVersionPolicyView"];
export type AppVersionPolicyInput = {
  app: string;
  platform: string;
  minVersion: string;
  currentVersion: string;
  forceUpdate: boolean;
};

export async function listAppVersions() {
  return unwrap(identity().GET("/api/identity/app-versions"));
}

export async function createAppVersion(input: AppVersionPolicyInput) {
  return unwrap(identity().POST("/api/identity/app-versions", { body: input }));
}

/** Every field is sent; changing `app`/`platform` onto a pair another policy holds is a 409. */
export async function updateAppVersion(id: string, input: AppVersionPolicyInput) {
  return unwrap(identity().PUT("/api/identity/app-versions/{id}", { params: { path: { id } }, body: input }));
}

export const APP_LABEL: Record<string, string> = { customer: "Customer", admin: "Admin" };
export const PLATFORM_LABEL: Record<string, string> = { android: "Android", ios: "iOS" };

/** "Customer Android" — how a policy is named on screen. */
export function policyName(p: Pick<AppVersionPolicy, "app" | "platform">) {
  return `${APP_LABEL[p.app] ?? p.app} ${PLATFORM_LABEL[p.platform] ?? p.platform}`;
}

/** The edit page's URL: `/app-versions/customer-android`, no GUID (the admin's record-URL rule). */
export function policyPath(p: Pick<AppVersionPolicy, "app" | "platform">) {
  return `/app-versions/${p.app}-${p.platform}`;
}
